import styled from 'styled-components';

export const Header = styled.header.attrs(() => ({
  className: 'SettingsTeacherProfileHeader',
}))`
  display: flex;
  padding: 20px;
  justify-content: space-between;
  border-bottom: 1px solid #dde4ea;
`;

export const Title = styled.span.attrs(() => ({
  className: 'SettingsTeacherProfileTitle',
}))`
  font-size: 18px;
  font-weight: bold;
  color: #4A4A4A;
`;
